import { css, html, PropertyValues } from 'lit';
import { property } from 'lit/decorators.js';
import './public-app-content-loader'
import { PublicAppElement } from './public-app-element';

export class PublicAppTabContainer extends PublicAppElement {
    static styles = [css`
        .tab-container{
            background: #fff;
        }
        .tab-header{
            line-height: 25px;
            margin-bottom: 2px;

        }
        .tab-panel-tab{
            background: #FFFFFF;
            color: #0072C6;
            font-size: 0.75rem;
            line-height: 1rem;
            border: 1px solid #CDD7E3;
            border-radius: 8px 8px 0 0;
            padding: 6px 16px;
        }
        .tab-panel-tab.selected{
            background: #0072C6;
	        color: #FFFFFF;
        }
        .tab-panel-tab:hover{
            background: #FAFBFD;
            color: #043673;
            cursor: pointer;
        }
        .tab-panel-tab.selected:hover{
            background: #043673;
            cursor: pointer;
            color: #FFFFFF;
        }
    `]

    @property({ type: Number }) accessor currentSelectedTab: number = 0;

    private tabDefinitions: any;
    get tabs(): object {
        return this.tabDefinitions;
    }

    @property({ type: Object })
    set tabs(value: object) {
        const oldValue = this.tabDefinitions;
        this.tabDefinitions = value;
        this.requestUpdate('tabs', oldValue);
    }

    private _tabCount: number;
    get tabCount(): String {
        return this._tabCount + '';
    }
    @property({ type: String })
    set tabCount(value: String) {
        const oldValue = this._tabCount;
        this._tabCount = + value;
        this.requestUpdate('tabCount', oldValue);
    }

    firstUpdated(changedProperties: PropertyValues) {
        super.firstUpdated(changedProperties);
        setTimeout(() => { this.prepareTabs() }, 100);
    }

    prepareTabs() {
        let tabs = [{}];
        tabs.pop();
        for (let i = 1; i <= this._tabCount; i++) {
            let obj = {};
            obj["text"] = this.getAttribute("text_" + i);
            obj["url"] = this.getAttribute("url_" + i);
            tabs.push(obj);
        }
        this.tabs = tabs;
    }

    tabClicked(e: any) {
        if (!(this.tabDefinitions && this.tabDefinitions.length)) return;
        let elm = e && e.target
        let newTabIndex = elm.getAttribute("data-index");
        if (this.currentSelectedTab != newTabIndex) {
            this.currentSelectedTab = +newTabIndex;
        }
    }

    getContentUrl() {
        if (!(this.tabDefinitions && this.tabDefinitions.length && this.tabDefinitions[this.currentSelectedTab])) return "";
        return this.tabDefinitions[this.currentSelectedTab].url
    }

    reload() {
        this.shadowRoot?.querySelector("public-app-content-loader")?.reload();
    }

    render() {
        return !(this.tabDefinitions && this.tabDefinitions.length) ? html`` : this.renderTabs();
    }

    renderTabs() {
        return html`
        <div id="tab-container" class="tab-container">
        <div id="tab-header" class="tab-header">
        ${this.renderTabsIcons()}
        </div>
        <public-app-content-loader .systemEnv=${this.runMode} .appVersion=${this.appVersion}  widgetId="0" url="${this.getContentUrl()}"></public-app-content-loader>
        </div>
        `;
    }
    renderTabsIcons() {
        return html`
        ${this.tabDefinitions.map(
            (btn: any, index: number) => html`<span data-index=${index} class="tab-panel-tab ${index == this.currentSelectedTab ? 'selected' : ''}" @click=${this.tabClicked}>${btn.text}</span>`
        )}`;
    }
}
declare global {
    interface HTMLElementTagNameMap {
        'public-app-tab-container': PublicAppTabContainer;
    }
}